import { UPDATE_PAGE_TITLE } from '../types/currentPage'

const initState = {
  routeTitle: 'Settings',
}

export default (state = initState, action) => {
  switch (action.type) {
    case UPDATE_PAGE_TITLE:
      return { ...state, routeTitle: action.payload.title }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/currentPage.js